import React, { useCallback, useEffect, useState,useMemo } from "react";
import { Card, Pagination, Button, ConfigProvider, Input,Select,Form,Modal,Col} from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import nb from "../../img/nb.png"
import "./index.scss";
import zh_CN from "antd/es/locale/zh_CN";
const { TextArea } = Input
const { Search } = Input;
const { Option } = Select;

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}

export default function EntrepreneurialExpert(props) {
  const search=props;
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [currentCity, setCurrentCity] = useState(1); //城市
  const [currentCityTwo, setCurrentCityTwo] = useState("");
  const [countyLevel, setCountyLevel] = useState(0); //眉山市或其他市
  const handlePage = (page, pageSize) => {
    setCurrentPage(page);
  };
  const history = useHistory();
  const handleJobDetail = (id) => {
    history.push(`entrepreneurship/EntrepreneurialExpertDetails/${id}`);
  };
  const initiaList = ()=>{
    let params = {
      size:6,
      address:currentCityTwo == "不限"? "":currentCityTwo,
      current:currentPage,
      type:countyLevel,
      text:searchValue,
      descs:'update_time',
      epalExpertName:props.search
    }
    Http.get(Request.specialist(), {...params}, obj => {
      setData(obj.data?.data || []);
      setTotal(obj.data?.total || []);
  });
  }
  

  useEffect(() => {
    initiaList()
  }, [currentPage,currentCityTwo,searchValue]);

  useEffect(() => {
    initiaList()
  }, [search,]);



  return (
    <div className={"EntrepreneurialExpert_app"}>
        <div className='getjob_major_thin'>
          {data.map((item, index) => {
          return (
            <div onClick={()=>{handleJobDetail(item.id)}} className="ImbarkBase_center">
              <ul className="getjob_center_total">
                <div className="getjob_center_img_box"><img src={item.photoList[0]?.photoUrl || ''} alt="" /></div>
                
                <div className="getjob_center_total_top">
                  <p>{item.epalExpertName}</p>
                  <li>
                    <span className="work_unit" style={{fontSize:"12px"}}>
                      工作单位
                    </span>
                  </li>
                  <li>
                    <span style={{fontSize:"12px",fontWeight:900}}>
                      {item.epalExpertUnit}
                    </span>
                  </li>
                  <li>
                    <span style={{fontSize:"12px"}}>
                      擅长领域
                    </span>
                  </li>
                  <li>
                    <span style={{fontSize:"12px",fontWeight:900}}>
                      {item.epalExpertTechnology}
                    </span>
                  </li>
                  {/* <div className="pagination_jump_buttom">
                    <Button onClick={(e)=>{handleEnterprise(e)}} className="pagination_footer_but" type="primary">申请入驻</Button>
                    <Button className="pagination_footer_but">基地详情</Button>
                  </div> */}
                </div>
              </ul>
            </div>
            );
          })}
        </div>

        <ConfigProvider locale={zh_CN}>
          <Pagination
            total={total}
            itemRender={itemRender}
            showQuickJumper={{
              goButton: <Button className={"pagination_jump"}>确定</Button>,
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={handlePage}
            showSizeChanger={false}
            current={currentPage}
            defaultPageSize={6}
            style={{
              marginTop: 14,
              paddingRight: 24,
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </ConfigProvider>
    </div>
  );
}
